import React from 'react';
import styled from 'styled-components';
import Button from '../button';

export const BaseWistiaWrapper = styled('div')``

export const BaseWistiaButton = styled(Button)`
  // Ensure the svg is only as big as the text in the button, and vertically align it.
  svg {
    height: 1em;
    width: 1em;
    position: relative;
  }
`

export const YellowWistiaButton = styled(BaseWistiaButton)`
  font-size: 1.25rem;
  padding: 8px 20px;
`


export const PlayWistiaButtonWrapper = styled(BaseWistiaWrapper)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
`

export const PlayWistiaButton = styled('button')`
  svg {
    height: 1em;
    width: 1em;
    position: relative;
  }

  cursor: pointer;
  padding: 0;
  margin: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: transparent;
  transition: background-color @transition-timing;

  &:hover {
    background-color: fade(@modal-backdrop, 20%);
  }

  .buttonIconWrapper {
    position: relative;
    display: block;
  }

  svg {
    width: 50%;
    height: 50%;
    left: 25%;
    position: relative;
    display: block;
    top: 0;
  }

  // allow button to size differently based on states.
  &.small {
    svg {
      width: 25%;
      height: 25%;
      left: 37.5%;
    }
  }

  &.medium {
    svg {
      width: 33%;
      height: 33%;
      left: 33%;
    }
  }

  // These elements exist in the playButton svg itself
  .outer-circle {
    fill-opacity: 0.4;
    transition: fill-opacity @transition-timing;
  }

  .inner-circle {
    transition: fill-opacity @transition-timing;
  }

  &:hover .icon {
    .inner-circle {
      fill-opacity: 1;
    }

    .outer-circle {
      fill-opacity: 0.3;
      transition: fill-opacity @transition-timing;
    }
  }
`
